import { Table } from "./Table";
import { Form } from "./Form";

export const PointOfSale = {
  Table,
  Form,
};
